<template>
  <div>
    <div v-if="franchiseListForClub.length > 0">
      <div class="large-3 columns">
        Franchise :
        <multiselect
          v-model="chosenFranchise"
          :options="franchiseListForClub"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="true"
          :preserve-search="true"
          placeholder="rechercher..."
          :show-labels="false"
          label="name"
          track-by="name"
          :preselect-first="false">
        </multiselect>
      </div>
      <template v-if="chosenFranchise">
        <div class="large-3 columns">
          <div>Roster</div>
          <input :disabled="true" :value="chosenFranchise.ref_roster" type="text">
        </div>
        <div class="large-2 columns">
          <div class="row">
            <div class="large-8 large-centered columns">
              <div>Icône</div>
              <img ref="imgEditor" :src="chosenFranchise.icon_file_path"></img>
            </div>
          </div>
        </div>
        <div class="large-2 columns">
          <div>Propriétaire</div>
          <input :disabled="true" type="text">
        </div>
      </template>
    </div>
    <div v-else>
      <h5>Il n'y a pas de franchise libre dans cette ligue</h5>
    </div>
  </div>
</template>

<script>
import spinner from '../../common/spinner.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'franchiseChooser',
  components: {
    spinner,
    Multiselect
  },
  props: {
    club: Number
  },
  watch: {
    club: function (newClub, oldClub) {
      if (newClub) {
        this.chosenFranchise = null
        this.$store.dispatch('invalidateTeamList')
        this.$store.dispatch('refreshTeamListForClub', newClub)
      }
    },
    chosenFranchise: function (newFranchise, oldFranchise) {
      this.$emit('franchiseSelected', newFranchise)
    }
  },
  data () {
    return {
      chosenFranchise: null
    }
  },
  computed:
  {
    franchiseListForClub: function () {
      if (this.$store.getters.franchiseList) {
        return this.$store.getters.franchiseList.filter(f => {
          return f.league.Club.id === this.club
        })
      }
      return []
    }
  },
  created () {
    this.$store.dispatch('invalidateTeamList')
    this.$store.dispatch('refreshTeamList')
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// franchise-chooser.vue?293788f8